import { Injectable } from '@jack-henry/frontend-utils/di';

import { CompanyViewModel } from '@treasury/domain-components/view-models/company.viewModel';
import { CompanyUserSummary } from '@treasury/domain/company/user/entities';
import { TmSideDrawerService } from '@treasury/presentation/services/side-drawer';
import { TmToastPosture, TmToastService } from '@treasury/presentation/services/toast';
import { html } from 'lit';
import { RowActionCommand, RowActionCommandResult } from '../../base.cmd';
import { CompanyUserActionType } from '../user-actions.types';
import './overlays/drawers/user-auth-settings/user-auth-settings.component';

@Injectable()
export class TmAuthSettingsCommand implements RowActionCommand<
    CompanyUserSummary,
    CompanyUserActionType
> {
    constructor(
        private readonly sideDrawerService: TmSideDrawerService,
        private readonly toastService: TmToastService
    ) {}

    public command(
        company: CompanyViewModel,
        isUisEnabled: boolean
    ): RowActionCommandResult<CompanyUserSummary, CompanyUserActionType> {
        return {
            type: CompanyUserActionType.AuthenticationSettings,
            title: `${isUisEnabled ? 'TM ' : ''}Authentication Settings`,
            action: (user: CompanyUserSummary) => this.execute(user, company, isUisEnabled),
        };
    }

    private async execute(
        user: CompanyUserSummary,
        company: CompanyViewModel,
        isUisEnabled: boolean
    ) {
        this.sideDrawerService.open(
            html`<tm-bo-user-auth-settings
                .user=${user}
                .company=${company}
                @close=${() => {
                    this.sideDrawerService.close();
                }}
                @confirm=${async (e: CustomEvent) => this.handleConfirm(e, user)}
            ></tm-bo-user-auth-settings>`,
            `${isUisEnabled ? 'TM ' : ''}User Authentication Settings`
        );
    }

    private async handleConfirm(e: CustomEvent, user: CompanyUserSummary) {
        if (!user.id) {
            this.toastService.show(
                'An error occurred while resetting the user password',
                TmToastPosture.Danger
            );
            throw new Error('User ID is required');
        }
        // TODO: Take action on confirmation

        this.sideDrawerService.close();
    }
}
